import { alpha } from '@mui/material/styles';

const HIGHLIGHT_BG_ALPHA = 0.06;

export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  padding: '18px 20px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const titleStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const gridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px',
};

export const getTileStyles = isHighlight => ({
  padding: '12px 14px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${isHighlight ? palette.primary.main : palette.border.input}`,
  backgroundColor: ({ palette }) =>
    isHighlight ? alpha(palette.primary.main, HIGHLIGHT_BG_ALPHA) : palette.background.paper,
});
